import { takeEvery, call, put, select } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { getRoomDescriptionRequest, getRoomDescriptionResponse } from '../../slices/hotel';

function* getRoomDescriptionWorker({ payload: { code, description, currencyCode } }) {
  try {
    const roomDescriptions = yield select((store) => store.hotel.roomDescriptions);

    if (roomDescriptions[code] && roomDescriptions[code].description) {
      yield put(
        getRoomDescriptionResponse({
          code,
          description: roomDescriptions[code].description,
        }),
      );
    } else {
      const url = '/hotels/getRoomDescription?doGetFromCache=true';
      const config = {
        method: 'POST',
        url,
        data: JSON.stringify({ description, currencyCode }),
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const { data } = yield call(axios, config);
      yield put(getRoomDescriptionResponse({ code, description: data }));
    }
  } catch (error) {
    yield put(getRoomDescriptionResponse({ code, description: error }));
  }
}

function* getRoomDescriptionWatcher() {
  yield takeEvery(getRoomDescriptionRequest.toString(), getRoomDescriptionWorker);
}

export default getRoomDescriptionWatcher;
